import format from 'date-fns/format';
import { makeRequest } from '../../../../lib/api';

const CARMEN_OFFICE_CONTROLLER_PATH = '/v1/carmen/offices';

class carmenController {
  getOfficeAvailableDates({ officeId, date }) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return makeRequest('get', `${ CARMEN_OFFICE_CONTROLLER_PATH }/${ officeId }/dates?year=${ year }&month=${ month }`);
  }

  getOfficeAvailableTime({ officeId, date }) {
    const dateString = format(date, 'yyyy-MM-dd');
    return makeRequest('get', `${ CARMEN_OFFICE_CONTROLLER_PATH }/${ officeId }/time?date=${ dateString }`);
  }
}

export default new carmenController();
